import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import {
  ChatSettingsPage,
  chatSettingsQueryOptions,
  chatSettingsSearchSchema,
} from '@/features/chat-settings';

/** Anyone who works the inbox may look; the page gates editing per tab. */
export const Route = createFileRoute('/_authed/_active/s/$storeId/settings/chat')({
  staticData: { crumb: 'chatSettings:crumb' },
  validateSearch: chatSettingsSearchSchema,
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'conversations.read');
  },
  loader: ({ context, params }) =>
    context.queryClient
      .query({ ...chatSettingsQueryOptions(params.storeId), staleTime: 'static' })
      .catch(() => undefined),
  component: ChatSettingsPage,
});
